import React from 'react'

const AddIcon = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5 6.66675V13.3334M13.8334 10.0001H7.16669" stroke="#202327" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M18.8334 10.0001C18.8334 5.39771 15.1024 1.66675 10.5 1.66675C5.89765 1.66675 2.16669 5.39771 2.16669 10.0001C2.16669 14.6024 5.89765 18.3334 10.5 18.3334C15.1024 18.3334 18.8334 14.6024 18.8334 10.0001Z" stroke="#202327" strokeWidth="1.5"/>
</svg>

  )
}

export default AddIcon
